let AFClubStatus = {
	COMING_SOON: '1',
	OPENING_SOON: '2',
	NORMAL: '3'
};
